import { Card } from "pepsico-ds";
import { getDateWithFormat } from "../../utils/commons";
import ButtonGroupDynamic from "../common/ButtonGroupDynamic";
import "./survey.scss";

const cardStyles = {
  padding: "16px",
  borderRadius: "10px",
  boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.1)",
  backgroundColor: "#fff",
};

const deletableStatuses = ["draft", "scheduled", "completed"];

const SurveyCard = ({ surveyData, actionButtons, currentProgramTimezone }) => {
  const {
    id,
    title,
    status,
    segments,
    activeStartDate,
    activeEndDate,
    contentData,
  } = surveyData;

  const isDeletable = deletableStatuses.includes(status);
  const hasValidSegments = segments?.filter(Boolean).length > 0;
  return (
    <Card icon="" ellipsis="" style={cardStyles}>
      <div className="survey-image-wrapper">
        <img
          className="survey-image"
          src={contentData?.image_url}
          alt={title}
          width="180"
          height="189"
        />
      </div>
      <div className="card-header-survey">
        <div className={`status ${status.toLowerCase()} font-xxs`}>{status}</div>
        <div className="font-bold font-small">{title}</div>
        <div className="font-xs">ID: {id}</div>
      </div>
      <div className="card-info font-xxs">
        {contentData?.type && (
          <div className="meta-item">
            <span className="meta-label">Type</span>
            <span>{contentData.type}</span>
          </div>
        )}
        <div className="meta-item">
          <span className="meta-label">Segmentation</span>
          <span>{hasValidSegments ? "Yes" : "No"}</span>
        </div>
      </div>
      <div className="card-info font-xxs no-gap">
        <div className="meta-item no-margin">
          <span className="meta-label"> Start Date</span>
          <span>
            {activeStartDate
              ? getDateWithFormat(activeStartDate, currentProgramTimezone)
              : "N/A"}
          </span>
        </div>
        <div className="meta-item no-margin">
          <span className="meta-label">End Date</span>
          <span>
            {activeEndDate
              ? getDateWithFormat(activeEndDate, currentProgramTimezone)
              : "N/A"}
          </span>
        </div>
      </div>
      <div className={`button-group-container ${isDeletable ? "deletable" : ""}`}>
        <ButtonGroupDynamic
          items={actionButtons}
          spacing="0px"
          size="small"
          variant="control"
        />
      </div>
    </Card>
  );
};

export default SurveyCard;
